module.exports = __webpack_public_path__ + "img/tslogo.3f94c8c5.png";